import countriesCodes from "./country_codes.json";
import domainsValues from "./domains_values.json";

export const globalData = [
  {
    type: "textField",
    conditional: false,
    key: "name_A",
    required: true,
    id: 0,
    rank: 0,
    question: "specify_a_name_to_your_organization",
    fistStepQuestion: true,
    nextQuestion: 1,
    nextStepQuestion: 1,
    category: 0,
    initialValue: "",
  },
  {
    type: "autocomplete",
    conditional: false,
    key: "domaine_A",
    multi: false,
    required: true,
    id: 1,
    rank: 1,
    question: "your_industry_field",
    defaultValue: "",
    nextQuestion: 2,
    nextStepQuestion: 2,
    choises: domainsValues,
    category: 0,
    initialValue: null,
  },
  {
    type: "checkbox",
    conditional: false,
    required: true,
    key: "model_A",
    id: 2,
    rank: 2,
    question: "your_business_model",
    nextQuestion: 3,
    nextStepQuestion: 3,
    category: 0,
    choises: [
      {
        label: "B2B",
        value: "B2B",
        id: 1,
        xs: 12,
        sm: 12,
        md: 6,
        lg: 6,
      },
      {
        label: "B2C",
        value: "B2C",
        id: 2,
        xs: 12,
        sm: 12,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: [],
  },
  {
    type: "inputField",
    valueLabelDisplay: "off",
    forClient: true,
    nullStart: false,
    conditional: false,
    required: false,
    min: 0,
    maxB2B: 110,
    maxB2C: 120,
    keyB2B: "display_clients_number_A_B2B",
    keyB2C: "display_clients_number_A_B2C",
    id: 3,
    rank: 3,
    question: "",
    nextQuestion: 4,
    nextStepQuestion: 4,
    category: 0,
    step: 10,
    // marksB2B: [
    //   {
    //     value: 0,
    //     scaledValue: 0,
    //     label: "0",
    //   },
    //   {
    //     value: 10,
    //     scaledValue: 10,
    //     label: "10",
    //   },
    //   {
    //     value: 20,
    //     scaledValue: 50,
    //     label: "50",
    //   },
    //   {
    //     value: 30,
    //     scaledValue: 100,
    //     label: "100",
    //   },
    //   {
    //     value: 40,
    //     scaledValue: 500,
    //     label: "500",
    //   },
    //   {
    //     value: 50,
    //     scaledValue: 1000,
    //     label: "1k",
    //   },
    //   {
    //     value: 60,
    //     scaledValue: 2000,
    //     label: "2k",
    //   },
    //   {
    //     value: 70,
    //     scaledValue: 5000,
    //     label: "5k",
    //   },
    //   {
    //     value: 80,
    //     scaledValue: 7000,
    //     label: "7k",
    //   },
    //   {
    //     value: 90,
    //     scaledValue: 10000,
    //     label: "10k",
    //   },
    //   {
    //     value: 100,
    //     scaledValue: 50000,
    //     label: "50k",
    //   },
    //   {
    //     value: 110,
    //     scaledValue: 100000,
    //     label: "100k",
    //   },
    // ],
    // marksB2C: [
    //   {
    //     value: 0,
    //     scaledValue: 0,
    //     label: "0",
    //   },
    //   {
    //     value: 10,
    //     scaledValue: 10,
    //     label: "10",
    //   },
    //   {
    //     value: 20,
    //     scaledValue: 50,
    //     label: "50",
    //   },
    //   {
    //     value: 30,
    //     scaledValue: 100,
    //     label: "100",
    //   },
    //   {
    //     value: 40,
    //     scaledValue: 500,
    //     label: "500",
    //   },
    //   {
    //     value: 50,
    //     scaledValue: 1000,
    //     label: "1k",
    //   },
    //   {
    //     value: 60,
    //     scaledValue: 2000,
    //     label: "2k",
    //   },
    //   {
    //     value: 70,
    //     scaledValue: 5000,
    //     label: "5k",
    //   },
    //   {
    //     value: 80,
    //     scaledValue: 7000,
    //     label: "7k",
    //   },
    //   {
    //     value: 90,
    //     scaledValue: 10000,
    //     label: "10k",
    //   },
    //   {
    //     value: 100,
    //     scaledValue: 50000,
    //     label: "50k",
    //   },
    //   {
    //     value: 110,
    //     scaledValue: 100000,
    //     label: "100k",
    //   },
    //   {
    //     value: 120,
    //     scaledValue: 1000000,
    //     label: "1M",
    //   },
    // ],
    initialValue: 1,
  },
  {
    type: "inputField",
    valueLabelDisplay: "off",
    forClient: false,
    conditional: false,
    nullStart: false,
    required: false,
    key: "turnover_A",
    min: 1,
    max: 60,
    id: 4,
    rank: 4,
    question: "turnover_k",
    nextQuestion: 5,
    nextStepQuestion: null,
    lastStepQuestion: true,
    category: 0,
    step: 10,
    // marks: [
    //   {
    //     value: 0,
    //     scaledValue: 1,
    //     label: "1K",
    //   },
    //   {
    //     value: 10,
    //     scaledValue: 10,
    //     label: "10K",
    //   },
    //   {
    //     value: 20,
    //     scaledValue: 100,
    //     label: "100K",
    //   },
    //   {
    //     value: 30,
    //     scaledValue: 1000,
    //     label: "1M",
    //   },
    //   {
    //     value: 40,
    //     scaledValue: 10000,
    //     label: "10M",
    //   },
    //   {
    //     value: 50,
    //     scaledValue: 100000,
    //     label: "100M",
    //   },
    //   {
    //     value: 60,
    //     scaledValue: 1000000,
    //     label: "+1000M",
    //   },
    // ],
    initialValue: 1,
  },
  {
    type: "autocomplete",
    conditional: false,
    required: false,
    key: "head_office_country_B",
    id: 5,
    rank: 5,
    question: "where_is_your_head_office_located",
    nextQuestion: 6,
    nextStepQuestion: 6,
    defaultValue: "FR",
    fistStepQuestion: true,
    choises: countriesCodes,
    category: 1,
    initialValue: "FR",
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "externalised_HR_service_B",
    id: 6,
    rank: 6,
    question: "is_your_hr_activity_oursourced",
    nextQuestion: 7,
    nextStepQuestion: 7,
    category: 1,
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "inputField",
    valueLabelDisplay: "off",
    conditional: false,
    forClient: false,
    nullStart: false,
    required: true,
    min: 0,
    key: "number_of_employees_B",
    id: 7,
    rank: 7,
    question: "employees_number",
    nextQuestion: 8,
    nextStepQuestion: null,
    lastStepQuestion: true,
    category: 1,
    step: 10,
    // marks: [
    //   {
    //     value: 0,
    //     scaledValue: 1,
    //     label: "1",
    //   },
    //   {
    //     value: 10,
    //     scaledValue: 10,
    //     label: "10",
    //   },
    //   {
    //     value: 20,
    //     scaledValue: 50,
    //     label: "50",
    //   },
    //   {
    //     value: 30,
    //     scaledValue: 100,
    //     label: "100",
    //   },
    //   {
    //     value: 40,
    //     scaledValue: 250,
    //     label: "250",
    //   },
    //   {
    //     value: 50,
    //     scaledValue: 500,
    //     label: "500",
    //   },
    //   {
    //     value: 60,
    //     scaledValue: 1000,
    //     label: "+1000",
    //   },
    // ],
    initialValue: 1,
  },
  // {
  //   type: "nonLinear",
  //   nullStart: true,
  //   conditional: false,
  //   forClient: false,
  //   required: true,
  //   valueLabelDisplay: "off",
  //   min: 0,
  //   max: 70,
  //   key: "security_team_employees_number_B",
  //   id: 8,
  //   rank: 8,
  //   question: "how_many_employees_in_the_security_team",
  //   nextQuestion: 9,
  //   nextStepQuestion: null,
  //   step: 10,
  //   category: 1,

  //   marks: [
  //     {
  //       value: 0,
  //       scaledValue: 0,
  //       label: "0",
  //     },
  //     {
  //       value: 10,
  //       scaledValue: 1,
  //       label: "1",
  //     },
  //     {
  //       value: 20,
  //       scaledValue: 2,
  //       label: "2",
  //     },
  //     {
  //       value: 30,
  //       scaledValue: 5,
  //       label: "5",
  //     },
  //     {
  //       value: 40,
  //       scaledValue: 7,
  //       label: "7",
  //     },
  //     {
  //       value: 50,
  //       scaledValue: 10,
  //       label: "10",
  //     },
  //     {
  //       value: 60,
  //       scaledValue: 15,
  //       label: "15",
  //     },
  //     {
  //       value: 70,
  //       scaledValue: 20,
  //       label: "+20",
  //     },
  //   ],
  //   initialValue: 0,
  // },
  // {
  //   type: "slider",
  //   criticalApp: false,
  //   conditional: false,
  //   required: true,
  //   valueLabelDisplay: "on",
  //   key: "apps_daily_use_number_C",
  //   id: 24,
  //   rank: 24,
  //   min: 0,
  //   max: 100,
  //   question: "specify_number_of_used_sofware_applications",
  //   category: 2,
  //   nextQuestion: 25,
  //   nextStepQuestion: 25,
  //   step: 5,
  //   marks: [
  //     {
  //       value: 0,
  //       label: "0",
  //     },
  //     {
  //       value: 5,
  //       label: "",
  //     },
  //     {
  //       value: 10,
  //       label: "",
  //     },
  //     {
  //       value: 15,
  //       label: "",
  //     },
  //     {
  //       value: 20,
  //       label: "20",
  //     },
  //     {
  //       value: 25,
  //       label: "",
  //     },
  //     {
  //       value: 30,
  //       label: "",
  //     },
  //     {
  //       value: 35,
  //       label: "",
  //     },
  //     {
  //       value: 40,
  //       label: "40",
  //     },
  //     {
  //       value: 45,
  //       label: "",
  //     },
  //     {
  //       value: 50,
  //       label: "",
  //     },
  //     {
  //       value: 55,
  //       label: "",
  //     },
  //     {
  //       value: 60,
  //       label: "60",
  //     },
  //     {
  //       value: 65,
  //       label: "",
  //     },
  //     {
  //       value: 70,
  //       label: "",
  //     },
  //     {
  //       value: 75,
  //       label: "",
  //     },
  //     {
  //       value: 80,
  //       label: "80",
  //     },
  //     {
  //       value: 85,
  //       label: "",
  //     },
  //     {
  //       value: 90,
  //       label: "",
  //     },
  //     {
  //       value: 95,
  //       label: "",
  //     },
  //     {
  //       value: 100,
  //       label: "100",
  //     },
  //   ],
  //   initialValue: 1,
  // },
  {
    type: "radio",
    conditional: true,
    required: true,
    key: "service_delivery_D",
    id: 8,
    payloadEliminate: false,
    rank: 8,
    question: "are_you_a_service_provider",
    category: 2,
    nextQuestion: { true: 9, false: 11 },
    nextStepQuestion: { true: 9, false: null },
    fistStepQuestion: true,
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "nonLinear",
    nullStart: false,
    conditional: false,
    forClient: false,
    required: true,
    valueLabelDisplay: "on",
    min: 0,
    max: 50,
    key: "Sla_availability_D",
    id: 9,
    rank: 9,
    question: "what_is_your_sla_servcie_level_agreement",
    category: 2,
    nextQuestion: 10,
    nextStepQuestion: 10,
    step: 10,
    marks: [
      {
        value: 0,
        scaledValue: 0,
        label: "<90%",
      },
      {
        value: 10,
        scaledValue: 90,
        label: "90%",
      },
      {
        value: 20,
        scaledValue: 99,
        label: "99%",
      },
      {
        value: 30,
        scaledValue: 99.9,
        label: "99.9%",
      },
      {
        value: 40,
        scaledValue: 99.99,
        label: "99.99%",
      },
      {
        value: 50,
        scaledValue: 99.999,
        label: "99.999%",
      },
    ],
    initialValue: 0,
  },
  // {
  //   type: "radio",
  //   conditional: false,
  //   required: true,
  //   key: "kpi_support_method_D",
  //   category: 2,
  //   id: 14,
  //   rank: 14,
  //   question: "how_are_they_calculated",
  //   nextQuestion: 15,
  //   nextStepQuestion: 15,
  //   choises: [
  //     {
  //       value: "native_reporting_tool",
  //       id: 1,
  //       xs: 12,
  //       sm: 6,
  //       md: 6,
  //       lg: 12,
  //     },
  //     {
  //       value: "application_data_consolidation",
  //       id: 2,
  //       xs: 12,
  //       sm: 6,
  //       md: 6,
  //       lg: 12,
  //     },
  //     {
  //       value: "realtime_user_activity",
  //       id: 6,
  //       xs: 12,
  //       sm: 6,
  //       md: 6,
  //       lg: 12,
  //     },
  //     {
  //       value: "manual_reporting",
  //       id: 6,
  //       xs: 12,
  //       sm: 6,
  //       md: 6,
  //       lg: 12,
  //     },
  //   ],
  //   initialValue: null,
  // },

  {
    type: "radio",
    conditional: false,
    required: true,
    key: "subcontractors_presence_D",
    category: 2,
    id: 10,
    rank: 10,
    question: "do_you_have_subcontractors_mandatory_to_provide_the_service",
    nextQuestion: 11,
    nextStepQuestion: null,
    lastStepQuestion: true,
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },

  {
    type: "radio",
    conditional: true,
    required: true,
    key: "proprety_intellectuel",
    category: 3,
    id: 11,
    payloadEliminate: true,
    rank: 11,
    question: "do_you_have_intellectual_property_to_protect",
    fistStepQuestion: true,
    nextQuestion: { true: 12, false: 13 },
    nextStepQuestion: { true: 12, false: 13 },
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },

  {
    type: "checkbox",
    conditional: false,
    required: true,
    key: "intellectual_property_E",
    category: 3,
    id: 12,
    rank: 12,
    question: "which_one",
    nextQuestion: 13,
    nextStepQuestion: 13,
    choises: [
      {
        value: "patent",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "trademark",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "artistic_creation",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "software",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "source_code",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "business_data",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: [],
  },

  {
    type: "radio",
    conditional: true,
    required: true,
    key: "personal_data_E",
    category: 3,
    id: 13,
    payloadEliminate: false,
    rank: 13,
    question: "do_you_have_personal_data_about_your_customers",
    nextQuestion: { true: 14, false: null },
    nextStepQuestion: { true: 14, false: null },
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "multiTags",
    groupedData: false,
    label: "data",
    conditional: false,
    required: true,
    key: "personal_data_list_E",
    category: 3,
    multi: true,
    id: 14,
    rank: 14,
    question: "specify_data_types_stored_in_your_organization",
    nextQuestion: 15,
    nextStepQuestion: 15,
    persistData: true,
    data_key: "stocked_data_app",
    choises: [
      {
        value: "name",
        id: 1,
        category: "identity",
      },
      {
        value: "surname",
        id: 2,
        category: "identity",
      },
      {
        value: "pseudonym",
        id: 3,
        category: "identity",
      },
      {
        value: "date_of_birth",
        category: "identity",
        id: 4,
      },
      {
        value: "place_of_birth",
        category: "identity",
        id: 5,
      },
      {
        value: "photos",
        id: 6,
        category: "Media",
      },
      {
        value: "voice_recordings",
        category: "Media",
        id: 7,
      },
      {
        value: "video_recordings",
        category: "Media",
        id: 8,
      },
      {
        value: "fixed_phone_number",
        id: 9,
        category: "Contact",
      },
      {
        value: "mobile_phone_number",
        id: 10,
        category: "Contact",
      },
      {
        value: "mailing_address",
        id: 11,
        category: "Contact",
      },
      {
        value: "email_address",
        id: 12,
        category: "Contact",
      },
      {
        value: "IP_address",
        id: 13,
        category: "web_browsing",
      },
      {
        value: "computer_login",
        id: 14,
        category: "web_browsing",
      },
      {
        value: "cookie_identifier",
        id: 15,
        category: "web_browsing",
      },
      {
        value: "cookies",
        id: 16,
        category: "web_browsing",
      },
      {
        value: "fingerprint",
        id: 17,
        category: "biometrics",
      },
      {
        value: "venous_network",
        id: 18,
        category: "biometrics",
      },
      {
        value: "Hand_palm",
        id: 19,
        category: "biometrics",
      },
      {
        value: "retinal_pattern",
        id: 20,
        category: "biometrics",
      },
      {
        value: "license_number",
        id: 21,
        category: "unique_identifiers",
      },
      {
        value: "social_security_number",
        category: "unique_identifiers",
        id: 22,
      },
      {
        value: "national_number",
        category: "unique_identifiers",
        id: 23,
      },
      {
        value: "health_data",
        category: "general_individual_data",
        id: 24,
      },
      {
        value: "sexual_orientation",
        category: "general_individual_data",
        id: 25,
      },

      {
        value: "genetic_origin",
        category: "general_individual_data",
        id: 26,
      },
      {
        value: "political_orientation",
        category: "general_individual_data",
        id: 27,
      },
      {
        value: "religious_orientation",
        category: "general_individual_data",
        id: 28,
      },
    ],
    initialValue: [],
  },
  {
    type: "multiTags",
    groupedData: false,
    label: "data",
    conditional: false,
    required: true,
    key: "critical_personal_data_list_E",
    multi: true,
    id: 15,
    rank: 15,
    question: "which_data_is_stored_processed_and_anlysed_by_your_appications",
    nextQuestion: 16,
    nextStepQuestion: 16,
    getPersistData: true,
    data_key: "stocked_data_app",
    category: 3,
    choises: [],
    initialValue: [],
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "subcontractors_data_access_E",
    id: 16,
    rank: 16,
    question: "do_you_have_subcontractors_that_have_access_to_this_data",
    nextQuestion: 17,
    nextStepQuestion: null,
    lastStepQuestion: true,
    category: 3,
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: true,
    required: true,
    key: "disruption_level",
    id: 17,
    rank: 17,
    question: "how_would_you_describe_the_impact_of_the_disruption",
    nextQuestion: {total_disruption: 18, partial_disruption: 18, no_disruption:19 },
    nextStepQuestion: {total_disruption: 18, partial_disruption: 18, no_disruption:19 },
    fistStepQuestion: true,
    category: 4,
    choises: [
      {
        value: "total_disruption",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "partial_disruption",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "no_disruption",
        id: 3,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "inputRadio",
    conditional: false,
    required: true,
    key: "unavailability_cost",
    id: 18,
    rank: 18,
    question: "what_is_the_estimated_cost_of_losing_your_provided_services_for_one_hour",
    nextQuestion: 19,
    nextStepQuestion: 19,
    category: 4,
    choises: [
      {
        value: "i_know_the_cost",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "i_dont_know_the_cost",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "checkboxInput",
    conditional: false,
    required: true,
    key: "annualized_frequency",
    id: 19,
    rank: 19,
    question: "have_experienced_cyber_attack",
    nextQuestion:null, 
    nextStepQuestion:null ,
    category: 4,
    choises: [
      {
        key: "ransomware",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        key: "dos",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        key: "supply_chain",
        id: 3,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        key: "data_breaches",
        id: 4,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        key: "social_engineering",
        id: 5,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        key: "i_dont_know",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        key: "no_attack",
        id: 7,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "disruption_hours",
    id: 20,
    rank: 20,
    question: "how_long_was_your_service_unavailable",
    nextQuestion: 21,
    comboBox: true,
    nextStepQuestion: null,
    lastStepQuestion: true,
    category: 4,
    choises: [
      {
        label: "dayss",
        value: "days",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        label: "hourss",
        value: "hours",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        label: "minutess",
        value: "minutes",
        id: 3,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        label: "other_specify",
        value: "other_specify",
        id: 4,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: true,
    required: true,
    id: 21,
    key: "it_department",
    payloadEliminate: true,
    rank: 21,
    question: "do_you_have_an_it_department",
    nextQuestion: { true: 22, false: 24 },
    nextStepQuestion: { true: 22, false: 24 },
    category: 5,

    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "nonLinear",
    conditional: false,
    required: true,
    forClient: false,
    valueLabelDisplay: "off",
    nullStart: false,
    min: 1,
    max: 70,
    key: "it_department_employees_number_B",
    id: 22,
    rank: 22,
    question: "how_many_employees_in_the_it_department",
    nextQuestion: 23,
    nextStepQuestion: 23,
    category: 5,

    step: 10,
    marks: [
      {
        value: 1,
        scaledValue: 1,
        label: "1",
      },
      {
        value: 10,
        scaledValue: 5,
        label: "5",
      },
      {
        value: 20,
        scaledValue: 10,
        label: "10",
      },
      {
        value: 30,
        scaledValue: 25,
        label: "25",
      },
      {
        value: 40,
        scaledValue: 50,
        label: "50",
      },
      {
        value: 50,
        scaledValue: 75,
        label: "75",
      },
      {
        value: 60,
        scaledValue: 100,
        label: "100",
      },
      {
        value: 70,
        scaledValue: 200,
        label: "+200",
      },
    ],
    initialValue: 1,
  },
  {
    type: "nonLinear",
    nullStart: true,
    conditional: false,
    forClient: false,
    required: true,
    valueLabelDisplay: "off",
    min: 0,
    max: 70,
    key: "security_team_employees_number_B",
    id: 23,
    rank: 23,
    question: "how_many_employees_in_the_security_team",
    nextQuestion: 24,
    nextStepQuestion: 24,
    step: 10,
    category: 5,

    marks: [
      {
        value: 0,
        scaledValue: 0,
        label: "0",
      },
      {
        value: 10,
        scaledValue: 1,
        label: "1",
      },
      {
        value: 20,
        scaledValue: 2,
        label: "2",
      },
      {
        value: 30,
        scaledValue: 5,
        label: "5",
      },
      {
        value: 40,
        scaledValue: 7,
        label: "7",
      },
      {
        value: 50,
        scaledValue: 10,
        label: "10",
      },
      {
        value: 60,
        scaledValue: 15,
        label: "15",
      },
      {
        value: 70,
        scaledValue: 20,
        label: "+20",
      },
    ],
    initialValue: 0,
  },
  {
    type: "radio",
    conditional: true,
    required: true,
    key: "datacenter_C",
    id: 24,
    payloadEliminate: false,
    category: 5,
    rank: 24,
    question: "do_you_have_a_data_center",
    nextQuestion: { yes_dedicated: 25, yes_shared: 25, no: 28 },
    nextStepQuestion: { yes_dedicated: 25, yes_shared: 25, no: 28 },
    choises: [
      {
        value: "yes_dedicated",
        id: 1,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "yes_shared",
        id: 2,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "no",
        id: 4,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "datacenter_number_C",
    id: 25,
    rank: 25,
    question: "how_many_datacenter_do_you_have",
    nextQuestion: 26,
    nextStepQuestion: 26,
    category: 5,
    choises: [
      {
        label: "1",
        value: 1,
        id: 1,
        xs: 12,
        sm: 3,
        md: 3,
        lg: 4,
      },
      {
        label: "2",
        value: 2,
        id: 2,
        xs: 12,
        sm: 3,
        md: 3,
        lg: 4,
      },

      {
        label: "+3",
        value: 3,
        id: 3,
        xs: 12,
        sm: 3,
        md: 3,
        lg: 4,
      },
    ],
    initialValue: null,
  },
  {
    type: "checkbox",
    conditional: false,
    required: true,
    key: "datacenter_location_C",
    id: 26,
    rank: 26,
    question: "location_of_datacenters",
    category: 5,
    nextQuestion: 27,
    nextStepQuestion: 27,
    choises: [
      {
        value: "latin_america",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "asia_pacific",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "rest_europe",
        id: 3,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "africa",
        id: 4,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "europe_union",
        id: 5,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "middle_east",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "china",
        id: 7,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "north_amercia",
        id: 8,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: [],
  },
  {
    type: "multiTags",
    groupedData: true,
    conditional: false,
    required: true,
    key: "system_equipments_C",
    category: 5,
    label: "system_equipments",
    id: 27,
    rank: 27,
    question: "select_hardware_equipement_that_you_own_in_datacenters",
    nextQuestion: 28,
    nextStepQuestion: 28,
    choises: [
      {
        value: "Router",
        category: "Network",
        id: 1,
      },
      {
        value: "Switch",
        category: "Network",
        id: 2,
      },
      {
        value: "firewalls",
        category: "Network",
        id: 3,
      },
      {
        value: "wireless_access_points",
        category: "Network",
        id: 4,
      },
      {
        value: "Modems",
        category: "Network",
        id: 5,
      },
      {
        value: "signal_repeaters_and_amplifiers",
        category: "Network",
        id: 6,
      },
      {
        value: "load_balancer",
        category: "Network",
        id: 7,
      },
      {
        value: "vpn",
        category: "Network",
        id: 8,
      },
      {
        value: "network_analyzers",
        category: "Network",
        id: 9,
      },
      {
        value: "network_time_protocol",
        category: "Network",
        id: 10,
      },
      {
        value: "servers",
        category: "system",
        id: 11,
      },
      {
        value: "client_computer_and_devices",
        category: "system",
        id: 12,
      },
      {
        value: "operating_systems",
        category: "system",
        id: 13,
      },
      {
        value: "network_management_software",
        category: "system",
        id: 14,
      },
      {
        value: "workstations",
        category: "system",
        id: 15,
      },
      {
        value: "mobile_device_management_solutions",
        category: "system",
        id: 16,
      },
      {
        value: "configuration_management_tools",
        category: "system",
        id: 17,
      },
      {
        value: "patch_management_software",
        category: "system",
        id: 18,
      },
      {
        value: "hard_drives",
        category: "storage",
        id: 19,
      },
      {
        value: "network_attached_storage",
        category: "storage",
        id: 20,
      },
      {
        value: "san",
        category: "storage",
        id: 21,
      },
      {
        value: "backup_solutions",
        category: "storage",
        id: 22,
      },
      {
        value: "cloud_storage_solutions",
        category: "storage",
        id: 23,
      },
      {
        value: "tss",
        category: "storage",
        id: 24,
      },
      {
        value: "storage_management_software",
        category: "storage",
        id: 25,
      },
      {
        value: "raid",
        category: "storage",
        id: 26,
      },
      {
        value: "database_servers",
        category: "databases",
        id: 27,
      },
      {
        value: "dbms",
        category: "databases",
        id: 28,
      },
      {
        value: "data_backup_systems",
        category: "databases",
        id: 29,
      },
      {
        value: "data_warehousing_solutions",
        category: "databases",
        id: 30,
      },
      {
        value: "data_replication_tools",
        category: "databases",
        id: 31,
      },
      {
        value: "noSQL_databases",
        category: "databases",
        id: 32,
      },
      {
        value: "virtualization_servers",
        category: "virtualization",
        id: 33,
      },
      {
        value: "hyperviseurs",
        category: "virtualization",
        id: 34,
      },
      {
        value: "virtualization_management_solutions",
        category: "virtualization",
        id: 35,
      },
      {
        value: "application_virtualization_solutions",
        category: "virtualization",
        id: 36,
      },
      {
        value: "desktop_virtualization_solutions",
        category: "virtualization",
        id: 37,
      },
      {
        value: "virtualization_security_tools",
        category: "virtualization",
        id: 38,
      },
      {
        value: "antivirus_and_anti-malware_solutions",
        category: "security",
        id: 39,
      },
      {
        value: "ids_ips",
        category: "security",
        id: 40,
      },
      {
        value: "utm",
        category: "security",
        id: 41,
      },
      {
        value: "siem",
        category: "security",
        id: 42,
      },
      {
        value: "dlp",
        category: "security",
        id: 43,
      },
      {
        value: "firewall_management_software",
        category: "security",
        id: 44,
      },
      {
        value: "physical_security_systems",
        category: "security",
        id: 45,
      },
    ],
    initialValue: [],
  },
  {
    type: "radio",
    conditional: true,
    required: true,
    key: "cloud_usage_C",
    id: 28,
    payloadEliminate: false,
    rank: 28,
    question: "do_you_use_public_cloud_services",
    category: 5,
    nextQuestion: { true: 29, false: 31 },
    nextStepQuestion: { true: 29, false: 31 },
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "checkbox",
    conditional: false,
    required: true,
    key: "cloud_providers_C",
    id: 29,
    rank: 29,
    question: "which_cloud_providers_do_you_use",
    category: 5,
    nextQuestion: 30,
    nextStepQuestion: 30,
    withTextField: true,
    relatedValue: "other",
    choises: [
      {
        value: "AWS",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "AZURE",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "GCP",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "IBM",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "OVH",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "AlibabaCloud",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "other",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: [],
  },
  {
    type: "multiTags",
    groupedData: true,
    conditional: false,
    required: true,
    key: "service_model_C",
    label: "service_model",
    id: 30,
    rank: 30,
    question: "specify_used_service_types",
    category: 5,
    nextQuestion: 31,
    nextStepQuestion: 31,
    choises: [
      {
        value: "Virtual_machines",
        id: 1,
        category: "Iaas",
      },
      {
        value: "Bare_ metal",
        id: 2,
        category: "Iaas",
      },
      {
        value: "iaas_other",
        id: 3,
        category: "Iaas",
      },
      {
        value: "Kubernetes",
        id: 4,
        category: "Paas",
      },
      {
        value: "serverless",
        id: 5,
        category: "Paas",
      },
      {
        value: "db_aas",
        id: 6,
        category: "Paas",
      },
      {
        value: "sap",
        id: 7,
        category: "Paas",
      },
      {
        value: "app_development",
        id: 8,
        category: "Paas",
      },
      {
        value: "Openshift",
        id: 9,
        category: "Paas",
      },
      {
        value: "paas_other",
        id: 9,
        category: "Paas",
      },
      {
        value: "salesforce",
        id: 10,
        category: "SaaS",
      },
      {
        value: "AzureAD",
        id: 11,
        category: "SaaS",
      },
      {
        value: "Office365",
        id: 12,
        category: "SaaS",
      },
      {
        value: "Adobe_creative",
        id: 13,
        category: "SaaS",
      },
      {
        value: "Gsuite",
        id: 14,
        category: "SaaS",
      },
      {
        value: "ServiceNow",
        id: 15,
        category: "SaaS",
      },
      {
        value: "Zendesk",
        id: 16,
        category: "SaaS",
      },
      {
        value: "Atlassian",
        id: 17,
        category: "SaaS",
      },
      {
        value: "Oracle",
        id: 18,
        category: "SaaS",
      },
      {
        value: "saas_other",
        id: 19,
        category: "SaaS",
      },
    ],
    initialValue: [],
  },

  {
    type: "radio",
    conditional: true,
    required: true,
    key: "software_type",
    id: 31,
    payloadEliminate: false,
    category: 5,
    rank: 31,
    question: "office_software_type",
    nextQuestion: { google_workspace: 32, microsoft_office: 33, other: 34 },
    nextStepQuestion: { google_workspace: 32, microsoft_office: 33, other: 34 },
    choises: [
      {
        value: "google_workspace",
        id: 1,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "microsoft_office",
        id: 2,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "other",
        id: 4,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
    initialValue: null,
  },

  {
    type: "radio",
    conditional: false,
    required: true,
    key: "software_formula",
    id: 32,
    payloadEliminate: false,
    category: 5,
    rank: 32,
    question: "what_is_your_formula",
    nextQuestion: 34,
    nextStepQuestion: 34,
    choises: [
      {
        value: "business_starter",
        id: 1,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "business_standard",
        id: 2,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "business_plus",
        id: 3,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "workspace_entreprise",
        id: 4,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "software_formula",
    id: 33,
    payloadEliminate: false,
    category: 5,
    rank: 33,
    question: "what_is_your_formula",
    nextQuestion: 34,
    nextStepQuestion: 34,
    choises: [
      {
        value: "business_basic",
        id: 1,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "business_standard",
        id: 2,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "business_premium",
        id: 3,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "apps_for_business",
        id: 4,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "office_access",
    id: 34,
    payloadEliminate: false,
    category: 5,
    rank: 34,
    question: "office_access_employee",
    nextQuestion: 35,
    nextStepQuestion: null,
    lastStepQuestion: true,
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "some_of_them",
        id: 3,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: true,
    required: true,
    key: "WebApp_status_F",
    id: 35,
    payloadEliminate: false,
    category: 6,
    rank: 35,
    question: "do_you_have_web_app",
    nextQuestion: { true: 36, in_progress: 37, false: null },
    nextStepQuestion: { true: 36, in_progress: 37, false: null },
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "in_progress",
        id: 4,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
    initialValue: null,
  },
  {
    type: "date",
    conditional: false,
    key: "WebApp_Launch_Date_F",
    required: true,
    id: 36,
    rank: 36,
    question: "select_lanuch_date",
    nextQuestion: 37,
    nextStepQuestion: 37,
    category: 6,
    initialValue: null,
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "MobileApp_status_F",
    id: 37,
    payloadEliminate: false,
    category: 6,
    rank: 37,
    question: "do_you_have_mobile_app",
    nextQuestion: 38,
    nextStepQuestion: 38,
    lastStepQuestion: false,
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
      {
        value: "in_progress",
        id: 4,
        xs: 12,
        sm: 4,
        md: 4,
        lg: 4,
      },
    ],
    initialValue: null,
  },

  {
    type: "multiTags",
    groupedData: false,
    conditional: false,
    required: true,
    key: "WebApp_scopes_F",
    label: "app_fields",
    id: 38,
    rank: 38,
    question: "specify_app_area",
    category: 6,
    nextQuestion: 39,
    nextStepQuestion: 39,
    choises: [
      {
        value: "Web3",
        id: 1,
      },
      {
        value: "Deeptech",
        id: 2,
      },
      {
        value: "Artificial_intelligence",
        id: 3,
      },
      {
        value: "Cloud",
        id: 4,
      },
      {
        value: "Cyber security",
        id: 5,
      },
      {
        value: "Data_analytics_and_business_intelligence",
        id: 6,
      },
      {
        value: "CRM",
        id: 7,
      },
      {
        value: "Diversity_and_inclusion",
        id: 8,
      },
      {
        value: "Fintech",
        id: 9,
      },
      {
        value: "Healthtech",
        id: 9,
      },
      {
        value: "Sustainability_and_climate_tech",
        id: 10,
      },
      {
        value: "Human_ressources",
        id: 11,
      },
      {
        value: "Metaverse_gaming_and_entertainement",
        id: 12,
      },
      {
        value: "IoT",
        id: 13,
      },
      {
        value: "Smart_city_and_mobility",
        id: 14,
      },
      {
        value: "Retail_e-commerce_and_luxury",
        id: 15,
      },
      {
        value: "Sport_performence_and_competition",
        id: 16,
      },
      {
        value: "Legal_tech",
        id: 17,
      },
      {
        value: "Industry",
        id: 18,
      },
      {
        value: "5G_and_connectivity",
        id: 19,
      },
      {
        value: "Account_tech",
        id: 20,
      },
      {
        value: "Biotech",
        id: 21,
      },
      {
        value: "Foodtech",
        id: 22,
      },
      {
        value: "Cleantech",
        id: 23,
      },
      {
        value: "Hanidcap_technologies",
        id: 24,
      },
      {
        value: "Femtech",
        id: 25,
      },
      {
        value: "Insurance",
        id: 26,
      },
      {
        value: "Greentech",
        id: 27,
      },
      {
        value: "Property_technoligies_and_real_estate",
        id: 28,
      },
      {
        value: "Asset_management",
        id: 29,
      },
      {
        value: "Wealth_management",
        id: 30,
      },
      {
        value: "Art_and_design",
        id: 31,
      },
      {
        value: "Agriculture",
        id: 32,
      },
      {
        value: "Social_media",
        id: 33,
      },
      {
        value: "Multimedia_3D",
        id: 34,
      },
    ],
    initialValue: [],
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "WebApp_Dev_entity_F",
    category: 6,
    id: 39,
    rank: 39,
    question: "who_is_the_dev_entity",
    nextQuestion: 40,
    nextStepQuestion: 40,
    choises: [
      {
        value: "external",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "internal",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "internal_external",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
    ],
    initialValue: null,
  },
  {
    type: "slider",
    valueLabelDisplay: "on",
    conditional: false,
    forClient: false,
    nullStart: false,
    required: true,
    min: 0,
    max: 200,
    key: "WebApp_Dev_number_F",
    id: 40,
    rank: 40,
    question: "dev_number",
    nextQuestion: 41,
    nextStepQuestion: 41,
    category: 6,
    step: 10,
    marks: [
      {
        value: 0,
        label: "1",
      },
      {
        value: 10,
        label: "",
      },
      {
        value: 20,
        label: "",
      },
      {
        value: 30,
        label: "",
      },
      {
        value: 40,
        label: "",
      },
      {
        value: 50,
        label: "50",
      },
      {
        value: 60,
        label: "",
      },
      {
        value: 70,
        label: "",
      },
      {
        value: 80,
        label: "",
      },
      {
        value: 90,
        label: "",
      },
      {
        value: 100,
        label: "100",
      },
      {
        value: 110,
        label: "",
      },
      {
        value: 120,
        label: "",
      },
      {
        value: 130,
        label: "",
      },
      {
        value: 140,
        label: "",
      },
      {
        value: 150,
        label: "150",
      },
      {
        value: 160,
        label: "",
      },
      {
        value: 170,
        label: "",
      },
      {
        value: 180,
        label: "",
      },
      {
        value: 190,
        label: "",
      },
      {
        value: 200,
        label: "200",
      },
    ],
    initialValue: 1,
  },
  {
    type: "checkbox",
    conditional: false,
    required: true,
    key: "WebApp_Dev_models_F",
    id: 41,
    rank: 41,
    question: "dev_model",
    category: 6,
    nextQuestion: 42,
    nextStepQuestion: 42,
    choises: [
      {
        value: "waterfall",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "V_shaped",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "Prototyping",
        id: 3,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "Spiral",
        id: 4,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "iterative_incremental",
        id: 5,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "agile",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: [],
  },
  {
    type: "checkbox",
    conditional: false,
    required: true,
    key: "WebApp_Architectures_F",
    id: 42, //46
    rank: 42,
    question: "dev_architecht",
    category: 6,
    nextQuestion: null,
    nextStepQuestion: null,
    choises: [
      {
        value: "CMS",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "3tier",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "Microservice",
        id: 3,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "Serverless",
        id: 4,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: "eventdriven",
        id: 5,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: [],
  },
  {
    type: "multiTags",
    groupedData: false,
    conditional: false,
    required: true,
    key: "WebApp_CMS_F",
    label: "cms_list",
    id: 43, //47
    rank: 43,
    question: "specify_cms",
    category: 6,
    nextQuestion: null,
    nextStepQuestion: null,
    choises: [
      {
        value: "Wordpress",
        id: 1,
      },
      {
        value: "Shopify",
        id: 2,
      },
      {
        value: "Wix",
        id: 3,
      },
      {
        value: "Squarespace",
        id: 4,
      },
      {
        value: "Joomla!",
        id: 5,
      },
      {
        value: "Drupal",
        id: 6,
      },
      {
        value: "Blogguer",
        id: 7,
      },
      {
        value: "Bitrix",
        id: 8,
      },
      {
        value: "Magento",
        id: 9,
      },
      {
        value: "OpenCart",
        id: 9,
      },
      {
        value: "PrestaShop",
        id: 10,
      },
      {
        value: "Weebly",
        id: 11,
      },
      {
        value: "TYPO3",
        id: 12,
      },
      {
        value: "Bigcommerce",
        id: 13,
      },
    ],
    initialValue: [],
  },
  {
    type: "multiTags",
    groupedData: false,
    conditional: false,
    required: true,
    key: "WebApp_programming_F",
    label: "prog_lang",
    id: 44,//48
    rank: 44,
    question: "specify_programming_language",
    category: 6,
    nextQuestion: 45,
    nextStepQuestion: 45,
    choises: [
      {
        value: "Python",
        id: 1,
      },
      {
        value: "Javascript",
        id: 2,
      },
      {
        value: "Go",
        id: 3,
      },
      {
        value: "Java",
        id: 4,
      },
      {
        value: "Kotlin!",
        id: 5,
      },
      {
        value: "C/C++",
        id: 6,
      },
      {
        value: "C#",
        id: 7,
      },
      {
        value: "PHP",
        id: 8,
      },
      {
        value: "Swift",
        id: 9,
      },
      {
        value: "R",
        id: 9,
      },
      {
        value: "Ruby",
        id: 10,
      },
      {
        value: "Matlab",
        id: 11,
      },
      {
        value: "TypeScript",
        id: 12,
      },
      {
        value: "Scala",
        id: 13,
      },
      {
        value: "SQL",
        id: 14,
      },
      {
        value: "Html",
        id: 15,
      },
      {
        value: "CSS",
        id: 16,
      },
      {
        value: "NoSQL",
        id: 17,
      },
      {
        value: "Rust",
        id: 18,
      },
      {
        value: "Perl",
        id: 19,
      },
      {
        value: "Hack",
        id: 20,
      },
      {
        value: "Fortran",
        id: 21,
      },
      {
        value: "VisualBasic",
        id: 22,
      },
      {
        value: "Scratch",
        id: 23,
      },
      {
        value: "Lisp",
        id: 24,
      },
      {
        value: "jQuery",
        id: 25,
      },
      {
        value: "Ajax",
        id: 26,
      },
      {
        value: "Dart",
        id: 27,
      },
    ],
    initialValue: [],
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "WebApp_IA_status_F",
    category: 6,
    id: 45,//49
    rank: 45,
    question: "ia_app",
    nextQuestion: 46,
    nextStepQuestion: 46,
    choises: [
      {
        value: "IA_used",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "IA_integrated",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "no",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "devlopment",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "study",
        id: 6,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: true,
    required: true,
    key: "e_commerce_presence_D",
    category: 6,
    id: 46,
    rank: 46,
    question: "do_you_an_ecommerce_platform",
    nextQuestion: { true: 47, false: 48 },
    nextStepQuestion: { true: 47, false: 48 },
    choises: [
      {
        value: true,
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
      {
        value: false,
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
      },
    ],
    initialValue: null,
  },
  {
    type: "radio",
    conditional: false,
    required: true,
    key: "payment_process_D",
    category: 6,
    id: 47,
    rank: 47,
    question: "how_is_it_managed",
    nextQuestion: 48,
    nextStepQuestion: 48,
    choises: [
      {
        value: "fully_managed_externally",
        id: 1,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "fully_managed_internally",
        id: 2,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
      {
        value: "payment_processed_externally",
        id: 3,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 12,
      },
    ],
    initialValue: null,
  },
  {
    type: "input",
    conditional: false,
    key: "WebApp_Description_F",
    required: false,
    multiline: true,
    id: 48,
    rank: 48,
    question: "web_description",
    label: "Descirption...",
    category: 6,
    nextQuestion: null,
    nextStepQuestion: null,
    lastStepQuestion: true,
    initialValue: "",
  },
];
